import { outsideOverageArea } from '../components/toast/outside-overage-area-toast'

// export default async function getApn(url, params) {
//     try{
//       const api = await fetch(url, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(params),
//       });
//       const res = await api.json();
//       if(res.status === 'no parcel')
//         return {status: 'fail', msg: 'No parcels exist in selected area'}
//       if(res.status === 'session expired')
//         return {status: 'expire', msg: 'Your log-in session has expired.'}
//       return res
//     } catch (e) {
//       return {status: 'fail', msg: 'Something went wrong while retrieving APN. Please try again later'}
//     }
// }

// export async function getProperties(url, params) {
//   try{
//     const api = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(params),
//     });
//     const res = await api.json();
//     if(res.status === 'session expired')
//       return {status: 'expire', msg: 'Your log-in session has expired.'}
//     return res
//   } catch (e) {
//     return {status: 'fail', msg: 'Something went wrong while retrieving properties. Please try again later'}
//   }
// }

// export async function getReservoir(url, params) {
//   try{
//     const api = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(params),
//     });
//     const res = await api.json();
//     if(res.status === 'session expired')
//       return {status: 'expire', msg: 'Your log-in session has expired.'}
//     return res
//   } catch (e) {
//     return {status: 'fail', msg: 'Something went wrong while retrieving properties. Please try again later'}
//   }
// }

// export async function getWeatherHistory(url, params) {
//   try{
//     const api = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(params),
//     });
//     const res = await api.json();
//     if(res.status === 'session expired')
//       return {status: 'expire', msg: 'Your log-in session has expired.'}
//     return res
//   } catch (e) {
//     return {status: 'fail', msg: 'Something went wrong while retrieving properties. Please try again later'}
//   }
// }

export async function callAPI(endpoint, params) {
  var BASE_URL =
    document.location.protocol + '//' + document.location.hostname + ':4011'
  if (process.env.REACT_APP_ENV === 'staging')
    BASE_URL = 'https://staging-api.hydrascore.com'
  else if (process.env.REACT_APP_ENV === 'dev')
    BASE_URL = 'https://dev-api.hydrascore.com'
  else if (process.env.NODE_ENV === 'production')
    BASE_URL = 'https://api.hydrascore.com'
  const localAuth = localStorage.getItem('auth')
    ? JSON.parse(localStorage.getItem('auth'))
    : {}
  const sessionKey = localAuth.sessionKey

  try {
    const api = await fetch(BASE_URL + endpoint, {
      method: 'POST',
      headers: {
        authorization: 'Bearer ' + sessionKey,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    })
    const res = await api.json()

    if (res.status === 'session expired')
      return { status: 'expire', msg: 'Your log-in session has expired.' }
    else if (res.status === 'no parcel')
      return { status: 'fail', msg: 'No parcels exist in selected area.' }
    else if (api.status === 403 && res?.detail)
      if(res.detail === 'Outside the Coverage Area.')
        return {
          status: 'fail',
          msg: outsideOverageArea.key,
        }
      else {
        return {
          status: 'fail',
          msg: res.detail
        }
      }
    return res
  } catch (e) {
    console.log(e)
    return { status: 'fail', msg: 'Server timed out. Please try again later.' }
  }
}
